export default "__VITE_ASSET__D$bj4Xji__"